<script>
import axios from "axios";
import SelectWithSearch from "@/views/pages/Dilfoods/Common/SelectWithSearch.vue";
import {OpsPath} from "@/path";

export default {
  name: "add",
  computed: {
    OpsPath() {
      return OpsPath
    }
  },
  components: {SelectWithSearch},
  props : ['selected_op_g'],
  data(){
    return {
      form : {
        display_inline : false,
        is_variant : false
      },
      baseUrl : process.env.VUE_APP_API_BACKEND_URL,
      filters : [],
      food_type_options : [
        {key : 1 , value : "Vegetarian"},
        {key : 2 , value : "Non-vegetarian"},
        {key : 3 , value : "Eggetarian"},
        {key : 4 , value : "Not specified"},
      ]
    }
  },
  watch : {
    selected_op_g: {
      deep : true,
      handler(v){
        console.log(v);
        this.form = v;
      }
    }
  },
  mounted() {
    if(this.selected_op_g){
      this.form = this.selected_op_g;
    }
  },
  methods : {
    async saveOpg(){
      try {
        let res = await axios.post(this.baseUrl + OpsPath.SAVEOPS,this.form);
        if(res.data.status == true)
        {
          this.$bvToast.toast('Successfully added', {
            title: `Modifier added`,
            variant: 'success',
            solid: true
          });
          this.$bvModal.hide("bv-add-options");
          this.$emit("update");
        }
      }catch (e) {
        console.log(e);
      }
    }
  }
}
</script>

<template>
  <div class="row">
    <div class="col-sm-12 col-md-12">
      <b-container fluid>
        <b-row class="my-1">
          <b-col sm="12">
            <label>Title:</label>
          </b-col>
          <b-col sm="12">
            <b-form-input id="input-small" v-model="form.title" size="sm" placeholder="Enter title"></b-form-input>
          </b-col>
        </b-row>
        <b-row class="my-1">
          <b-col sm="12">
            <label>Default Sales Price: <i v-b-tooltip title="Price of the modifier as it`s displayed to your customers" class="fa fa-info-circle"></i></label>
          </b-col>
          <b-col sm="12">
            <b-input-group prepend="₹" size="sm"><b-form-input type="number" id="input-small" v-model="form.price" size="sm" placeholder="Enter Default Price"></b-form-input></b-input-group>
          </b-col>
        </b-row>
        <b-row class="my-1">
          <b-col sm="12">
            <label>Food Type:</label>
          </b-col>
          <b-col sm="12">
            <select-with-search :options-data="food_type_options" :key="food_type_options.length" :search_without_api="true" @selectedOption="((v) => form.food_type = v)" track_by="key" display="value"></select-with-search>
          </b-col>
        </b-row>
        <b-row class="my-1">
          <b-col sm="12" class="ml-0">
            <label>Description:</label>
          </b-col>
          <b-col sm="12">
            <b-form-textarea id="input-small" v-model="form.description" size="sm" placeholder="Enter description"></b-form-textarea>
          </b-col>
        </b-row>
        <b-row class="my-1">
          <b-col sm="6">
            <label>Is Available:</label>
            <b-form-checkbox switch v-model="form.available" name="check-button" size="sm"></b-form-checkbox>
          </b-col>
          <b-col sm="6">
            <label>Sold at store:</label>
            <b-form-checkbox switch v-model="form.sold_at_store" name="check-button" size="sm"></b-form-checkbox>
          </b-col>
        </b-row>
        <b-row class="my-1">
          <b-col sm="6">
            <label>Sort Order:</label>
            <b-form-input type="number" min="0" v-model="form.sort_order" id="input-small" size="sm" placeholder="Sort Order"></b-form-input>
          </b-col>
          <b-col sm="6">
            <label>Weight:</label>
            <b-form-input type="number" min="0" v-model="form.weight" id="input-small" size="sm" placeholder="Weight"></b-form-input>
          </b-col>
        </b-row>
        <b-row class="my-1">
          <b-col sm="12">
            <label>Attach To Modifier Group (optional):</label>
          </b-col>
          <b-col sm="12">
            <select-with-search @selectedOption="((v) => form.opt_grp_ref_ids = v)" :multi_select="true" :search_api="OpsPath.SEARCHOPGS" track_by="ref_id" display="title"></select-with-search>
          </b-col>
        </b-row>
        <b-row class="my-1 mt-2">
          <b-col sm="12">
            <b-button @click="saveOpg" class="btn btn-success">Submit</b-button>
          </b-col>
        </b-row>
      </b-container>
    </div>
  </div>
</template>

<style scoped>

</style>